import { useContext, useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { CurrentUserContext } from "./CurrentUserContext";
import axios from "axios";

function ProtectedRoute({ children }) {
    // const [isAuthenticated, setIsAuthenticated] = useState(null);
    const user = useContext(CurrentUserContext);
    const location = useLocation();

    // useEffect(() => {
    //     axios
    //         .get("/api/users/current-user/")
    //         .then(() => setIsAuthenticated(true))
    //         .catch(() => setIsAuthenticated(false));
    // }, []);

    // if (isAuthenticated === null) {
    //     return;
    // }

    // if (!isAuthenticated) {
    //     const next = location.pathname + location.search;
    //     window.location.href = `/login/?next=${encodeURIComponent(next)}`;
    //     return null;
    // }

    if (!user) {
        const next = location.pathname + location.search;
        window.location.href = `/login/?next=${encodeURIComponent(next)}`;
        return null;
    }

    return children;
}

export default ProtectedRoute;